import React, { FC, useEffect } from "react";

interface ScrollResetProps {
  children: React.ReactNode;
}

const ScrollReset: FC<ScrollResetProps> = (props) => {
  useEffect(() => {
    return () => {
      document.querySelector("#grid-container")?.scrollTo(0, 0);
    };
  }, [props.children]);

  return <>{props.children}</>;
};

export default ScrollReset;
